// Shared search contract: only exact identifiers attach native properties.
export function flattenProperties(value, prefix = '', rows = []) {
  for (const [key, v] of Object.entries(value || {})) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (v && typeof v === 'object' && !Array.isArray(v)) flattenProperties(v, path, rows);
    else rows.push([path, Array.isArray(v) ? JSON.stringify(v) : String(v ?? '')]);
  }
  return rows;
}
export function exactNative(object, objects = {}, external = {}) {
  const p = object.properties || {};
  return [p.ElementId, p.elementId, p.objectId, p.handle, p.externalId, p.UniqueId, object.originalId, object.name]
    .filter(v => v !== undefined && v !== null)
    .map(id => objects[String(id)] || external[String(id)]).find(Boolean);
}
export function objectFields(object, native) {
  const rows = [...flattenProperties(object.properties), ...flattenProperties(native?.properties)];
  const find = names => rows.find(([k, v]) => v && names.some(n => k.split('.').at(-1).toLowerCase() === n))?.[1] || '';
  return { rows, category: find(['category', 'categoryname', '類別']) || native?.type || '未分類',
    system: find(['system', 'system name', 'systemname', '系統']) || '未指定' };
}
export function matchesObject(object, fields, { query = '', category = '', system = '', property = '', value = '' } = {}) {
  const norm = v => String(v).toLocaleLowerCase();
  const haystack = norm([object.name, object.id, object.modelName, ...fields.rows.flat()].join(' '));
  return (!query || haystack.includes(norm(query))) && (!category || fields.category === category)
    && (!system || fields.system === system) && (!property && !value || fields.rows.some(([k, v]) =>
      (!property || norm(k).includes(norm(property))) && (!value || norm(v).includes(norm(value)))));
}
